import { en } from './en'
import { fr } from './fr'

export const ctaButtons = {
  en,
  fr
}